import React from 'react';
import './CompetitorScoreChartTooltip.css';

const CompetitorScoreChartTooltip = ({ children, position }) => {
  // Don't render anything if there's no content
  if (!children) {
    return null;
  }

  return (
    <div
      className="custom-recharts-tooltip"
      style={{
        position: 'fixed', // Positions relative to the viewport
        left: position.x,
        top: position.y,
        pointerEvents: 'none', // Prevents the tooltip from blocking mouse events
      }}
    >
      {children}
    </div>
  );
};

export default CompetitorScoreChartTooltip;
